module.exports = __webpack_public_path__ + "img/substitution_green.48e4766d.svg";